module.exports = __webpack_public_path__ + "img/9-blue-diamond.f4b5a7f4.png";